<template>
  <div>
    <h1 class="p-ml-3 p-mb-2">Bedrifter</h1>
    <DataTable
      :value="companies"
      rowHover
      :filters="filters" 
      sortField="companyname"
      :sortOrder="1"
    >
      <template #header>
        <div>
          <div class="p-d-flex p-jc-end">
            <Button label="Legg til" icon="pi pi-plus" @click="newCompany()" />
          </div>
        </div>
      </template>
      <Column field="companyname" header="Bedrifsnavn" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText 
            type="text" 
            v-model="filters['companyname']" 
            class="p-column-filter" 
            placeholder="Søk på navn"
          ></InputText>
        </template>
      </Column>
      
      <Column field="organizationnumber" header="Organisasjonsnummer" filterMatchMode="contains" :sortable="true">
        <template #body="slotProps">
            {{ formatOrgNr(slotProps.data.organizationnumber) }}
        </template>
        <template #filter>
          <InputText 
            type="text" 
            v-model="filters['organizationnumber']" 
            class="p-column-filter" 
            placeholder="Søk på org. nr"
          ></InputText>
        </template>
      </Column>
      <Column field="gpcandeclare" header="Kan Glør partner deklarere farlig avfall for bedriften" :sortable="true">
        <template #body="slotProps">
          <p>{{ slotProps.data.gpcandeclare ? 'Ja' : 'Nei' }}</p>
        </template>
      </Column>
      <Column>
        <template #body="slotProps">
          <div class="p-d-flex p-jc-end">
            <Button label="Velg bedrift" icon="pi pi-plus" @click="changeCompany(slotProps.data)" />
            <template v-if="isAdmin">
              <Button 
                v-if="slotProps.data.gpcandeclare" 
                label="Deklarere avfall" 
                v-tooltip.top="'Styrer om Glør Partner kan deklarere farlig avfall.'"
                class="p-ml-2 p-button-danger" 
                icon="pi pi-minus" 
                @click="gpcandeclare(slotProps.data, false)" 
              ></Button>
              <Button 
                v-else 
                v-tooltip.top="'Styrer om Glør Partner kan deklarere farlig avfall.'"
                label="Deklarere avfall" 
                class="p-button-secondary p-ml-2" 
                icon="pi pi-plus" 
                @click="gpcandeclare(slotProps.data, true)" 
              ></Button>
            </template>
          </div>
        </template>
      </Column>
      <template #footer>
        <div>
          <div class="p-d-flex p-jc-end">
            <Button label="Legg til" icon="pi pi-plus" @click="newCompany()" />
          </div>
        </div>
      </template>
    </DataTable>

  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
name: 'companiesList',

components: {
  DataTable,
  Column
},

data(){
  return {
    filters: {},
  }
},

mounted(){
  this.$store.dispatch('companies/all')
},

methods:{
  gpcandeclare(company, status){
    company.gpcandeclare = status
    this.$store.dispatch('companies/save', company)
  },
  formatOrgNr(str){
    return `${str.slice(0, 3)} ${str.slice(3,6)} ${str.slice(6,9)}` 
  },
  
  newCompany(){
    this.$router.push({ name: 'companyNew'}) 
  },
  
  changeCompany(company){
    this.$store.dispatch('companies/current', company).then(() => {
      this.$router.push({name: 'dashboard'})
      window.scrollTo(0, 0);
    })
  }
},

computed:{
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  },
  companies(){
    return this.$store.getters["companies/list"]
  }
}
}
</script>